(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function reorderSoldOut() {
    const grid = document.querySelector('.product-grid__item')?.parentElement;
    if (!grid) return;
    const items = Array.from(grid.querySelectorAll('.product-grid__item'));
    const inStock = items.filter(item => !item.querySelector('.color-custom-badge-sold-out'));
    const soldOut = items.filter(item => item.querySelector('.color-custom-badge-sold-out'));
    [...inStock, ...soldOut].forEach(item => grid.appendChild(item));
  }

  document.addEventListener('DOMContentLoaded', reorderSoldOut);

  } catch(e) { console.error(e); }
})();
})();
